// extracted by mini-css-extract-plugin
module.exports = {"insights":"FeaturedTiles_insights__GDK3_"};